/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamScreen = {
    properties: {
        team: {
            type: 'Team',
            isRequired: true,
        },
        squad: {
            type: 'SquadList',
            isRequired: true,
        },
        coaches: {
            type: 'CoachSmallList',
            isRequired: true,
        },
        successes: {
            type: 'SuccessList',
            isRequired: true,
        },
        teamFact: {
            type: 'any-of',
            contains: [{
                type: 'Translation',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        history: {
            type: 'LeagueList',
            isRequired: true,
        },
        matches: {
            type: 'MatchSmallList',
            isRequired: true,
        },
        topPlayer: {
            type: 'any-of',
            contains: [{
                type: 'PlayerStatisticsListV2',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        standingHistory: {
            type: 'any-of',
            contains: [{
                type: 'dictionary',
                contains: {
                    type: 'number',
                },
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        teamGoals: {
            type: 'any-of',
            contains: [{
                type: 'GoalTypeAmountList',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        playerStatistics: {
            type: 'any-of',
            contains: [{
                type: 'PlayerStatisticsListV2',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
